__turbopack_context__.v({
  "registerBanner": "BannerForRegistration-module-scss-module__uuzmrG__registerBanner",
  "registerBannerDescription": "BannerForRegistration-module-scss-module__uuzmrG__registerBannerDescription",
  "registerBannerTitle": "BannerForRegistration-module-scss-module__uuzmrG__registerBannerTitle",
});
